import { useContext } from "react";
import styles from "../DeleteStore/DeleteStoreModal.module.css";
import { deleteStoreFromDatabase } from '../../../hooks/Store';
import { StoresContext } from '../../../context/StoresContext';

function Modal({ closeModal }) {
  const { 
    selectedStore, 
    setIsDeletedStore,
    clearSuccess
   } = useContext(StoresContext);

  const deleteStore = async () => {
    if(selectedStore != null) {
        try {
          const response = await deleteStoreFromDatabase(selectedStore.id); 
          if (response) {
            setIsDeletedStore(true)
            clearSuccess()
            closeModal()
          } else {
            setIsDeletedStore(false)
              console.error("Failed to fetch stores or no stores found.");
          }
      } catch (error) {
          setIsDeletedStore(false)
          console.error("Error fetching stores:", error);
      }
    }
  }
  return (
    <div className={styles.modalBackground}>
      <div className={styles.modalContainer}>
        <div className={styles.content}>
            <h1>Deseja excluir a loja selecionada?</h1>
            <p>{"Id: "+selectedStore.id}</p>
            <p>{"Nome da loja: "+selectedStore.name}</p>
            <p>{"CNPJ: "+selectedStore.cnpj}</p>
            <p>{"Telefone: "+selectedStore.phone}</p>
        </div>
        <div className={styles.buttonContent}>
          <button className={styles.buttonConfirm} onClick={ deleteStore }>Deletar</button>
          <button onClick={ closeModal } className={styles.buttonCancel}>Cancelar</button>
        </div>
      </div>
    </div>
  );
}

export default Modal;
